export default __webpack_public_path__ + "static/media/flexible-payout-icon.979b7bea.svg";